import React from 'react';
import {useTranslation} from 'react-i18next';
import {Icon} from '@iconify/react';
import {RequestParam} from '../../../../../../incase-domain/requestParams';
import {isRedirectParam, REDIRECT_EXAMPLE_URI, REDIRECT_URI_PARAM} from '../../../../../../utils/redirect';

interface RedirectGuidelinesProps {
    requestParams: RequestParam[];
}

function RedirectGuidelines({requestParams}: RedirectGuidelinesProps): JSX.Element | null {
    const {t} = useTranslation();

    if (!requestParams.some((param) => isRedirectParam(param.key))) return null;

    return (
        <div className="c-slugSettings__redirect">
            <div className="c-slugSettings__redirectTitle">
                <Icon icon="solar:undo-left-round-linear" width={16} />
                {t('presEditPage.settings.shortLink.redirectGuide.title')}
            </div>
            <p>{t('presEditPage.settings.shortLink.redirectGuide.info', {param: REDIRECT_URI_PARAM})}</p>
            <p className="c-slugSettings__redirectWarning">
                <Icon icon="solar:danger-triangle-linear" width={16} />
                <span>
                    {t('presEditPage.settings.shortLink.redirectGuide.encodeWarning')} <code>{REDIRECT_EXAMPLE_URI}</code> →{' '}
                    <code>{encodeURIComponent(REDIRECT_EXAMPLE_URI)}</code>
                </span>
            </p>
            <p>{t('presEditPage.settings.shortLink.redirectGuide.shortLinkTip', {param: REDIRECT_URI_PARAM})}</p>
        </div>
    );
}

export default RedirectGuidelines;
